import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram } from 'lucide-react';
import CloudfiMusicLogo from './CloudfiMusicLogo';

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <CloudfiMusicLogo size={38} className="footer-logo-svg" />
          <span>An independent lofi music label</span>
          <span className="footer-company">by Xu&#226;n Di&#7879;u Media Co., Ltd</span>
          <div className="footer-social">
            <a href="https://www.instagram.com/cloudfimusic/" target="_blank" rel="noopener noreferrer" className="footer-social-link" aria-label="Instagram">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div className="footer-columns">
          <div className="footer-col">
            <h4 className="footer-col-title">Navigate</h4>
            <Link to="/artists">Artists</Link>
            <Link to="/releases">Releases</Link>
            <Link to="/about">About</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">For Artists</h4>
            <Link to="/demo-submission">Submit Demo</Link>
            <Link to="/licensing">Licensing</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/faq">FAQ</Link>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Legal</h4>
            <Link to="/music-policy">Music Policy</Link>
            <Link to="/release-policy">Release Policy</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </div>
          <div className="footer-col">
            <h4 className="footer-col-title">Contact</h4>
            <a href="mailto:info@cloudfimusic.com" className="footer-email">
              <Mail size={13} /> info@cloudfimusic.com
            </a>
            <a href="https://www.instagram.com/cloudfimusic/" target="_blank" rel="noopener noreferrer" className="footer-ig-link">
              <Instagram size={13} /> @cloudfimusic
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <span>&copy; {new Date().getFullYear()} CloudfiMusic &middot; Xu&#226;n Di&#7879;u Media Co., Ltd. All rights reserved.</span>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms-of-service">Terms</Link>
            <Link to="/cookie-policy">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
